import React from 'react';
import { useAuth } from '@domain/auth/auth.hook';
import { useFormData } from '@domain/hooks/use.form.data';
import { RequestDialog } from '@components/dialog/request.dialog';
import { DescText } from '@styles/common';
import { ToggleDialogProps } from '@screens/players/player.actions/toggles/toggle.dialog.props';

const BlockPlayerDialog = ({ player, requestChange, ...rest }: ToggleDialogProps) => {
  const { authorizedServices } = useAuth();

  const { blocked } = player.toggles;

  const formData = useFormData(player.pid, function requestPlayerBlock(data, cancelToken) {
    return authorizedServices.patch('/admin/toggles/block-player', { params: data, cancelToken, pid: player.pid, block: !blocked });
  });

  const props = {
    icon: 'person_off',
    title: blocked ? 'Unblock player' : 'Block player',
    successMsg: `Player ${blocked ? 'unblocked' : 'blocked'} successfully!`,
    onSuccess: requestChange,
  };

  return (
    <RequestDialog formData={formData} {...props} {...rest}>
      <DescText>
        Are you sure you want to <strong>{blocked ? 'unblock' : 'block'}</strong> this player?
      </DescText>
    </RequestDialog>
  );
};

export default BlockPlayerDialog;
